import React, { useState } from 'react'
import { DateTime } from 'luxon'

const CalendarSquare = ({ date, events }) => {
  if (!events || !events[0]) {
    return (
      <li>
        <div className="date">
          {date?.day}
        </div>
      </li>
    )
  }

  const bgImage = events[0].croppedImage
  const mainLink = `/events/${events[0].slug}`
  return (
    <li>
      <div className="date">
        {date?.day}
      </div>
      <div className="bg-image" style={{backgroundImage: `url('${bgImage}')`}} />
      <div className="event-title">
        {
          events ? (
            events.sort((a, b) => {
              return a
            }).map(e => {
              return (
                <div key={e.id} className="mt-1 pt-1 border-top">
                  <a href={`/events/${e.slug}`}>
                    {e.thisEventTime.toFormat('h:mma').toLowerCase()}: {e.title}
                  </a>
                </div>
              )
            })
          ) : null
        }
      </div>
    </li>
  )
}

export default CalendarSquare
